export const GET_DRIVERS_STATUS = 'GET_DRIVERS_STATUS';
export const GET_DRIVERS_MPG = 'GET_DRIVERS_MPG';
export const GET_DRIVERS_LATE = 'GET_DRIVERS_LATE';
